export default __webpack_public_path__ + "static/media/3.246a89f5.png";